import { render, staticRenderFns } from "./Picklrs.vue?vue&type=template&id=34457b93&scoped=true&"
import script from "./Picklrs.vue?vue&type=script&lang=js&"
export * from "./Picklrs.vue?vue&type=script&lang=js&"
import style0 from "./Picklrs.vue?vue&type=style&index=0&id=34457b93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34457b93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34457b93')) {
      api.createRecord('34457b93', component.options)
    } else {
      api.reload('34457b93', component.options)
    }
    module.hot.accept("./Picklrs.vue?vue&type=template&id=34457b93&scoped=true&", function () {
      api.rerender('34457b93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/Picklrs.vue"
export default component.exports